import React from 'react';
import { ThemeContextValue } from '@weave-design/theme-context';
import { INFO360_THEMES } from '../theme.types';
import { weaveThemes } from '../weave.types';

interface WeaveThemeContextProps {
	theme: INFO360_THEMES;
	setTheme: (newTheme: INFO360_THEMES, updateStorage?: boolean) => void;
	weaveThemeConsumer: ThemeContextValue;
	isWeaveTheme?: boolean;
}

export const WeaveThemeContext = React.createContext<WeaveThemeContextProps>({
	theme: INFO360_THEMES.Classic,
	setTheme: () => {},
	weaveThemeConsumer: weaveThemes[INFO360_THEMES.Classic],
});

export const useWeaveThemeContext = () => {
	const context = React.useContext(WeaveThemeContext);
	if (!context) {
		throw new Error('useWeaveThemeContext must be used within a Provider');
	}
	return context;
};
